// CPF Validation
export const validateCPF = (cpf) => {
  // Remove non-digits
  cpf = cpf.replace(/\D/g, '');
  
  // CPF must have 11 digits
  if (cpf.length !== 11) return false;
  
  // Check for known invalid CPFs (all same digit)
  if (/^(\d)\1{10}$/.test(cpf)) return false;
  
  // Calculate first check digit
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf[i]) * (10 - i);
  }
  let resto = soma % 11;
  let digito1 = resto < 2 ? 0 : 11 - resto;
  
  if (parseInt(cpf[9]) !== digito1) return false;
  
  // Calculate second check digit
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf[i]) * (11 - i);
  }
  resto = soma % 11;
  let digito2 = resto < 2 ? 0 : 11 - resto;
  
  return parseInt(cpf[10]) === digito2;
};

// CNPJ Validation
export const validateCNPJ = (cnpj) => {
  // Remove non-digits
  cnpj = cnpj.replace(/\D/g, '');
  
  // CNPJ must have 14 digits
  if (cnpj.length !== 14) return false;
  
  // Check for known invalid CNPJs (all same digit)
  if (/^(\d)\1{13}$/.test(cnpj)) return false;
  
  // Weights for first digit
  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let soma = 0;
  for (let i = 0; i < 12; i++) {
    soma += parseInt(cnpj[i]) * weights1[i];
  }
  let resto = soma % 11;
  let digito1 = resto < 2 ? 0 : 11 - resto;
  
  if (parseInt(cnpj[12]) !== digito1) return false;
  
  // Weights for second digit
  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  soma = 0;
  for (let i = 0; i < 13; i++) {
    soma += parseInt(cnpj[i]) * weights2[i];
  }
  resto = soma % 11;
  let digito2 = resto < 2 ? 0 : 11 - resto;
  
  return parseInt(cnpj[13]) === digito2;
};

// Validate CPF or CNPJ based on length
export const validateCpfCnpj = (value) => {
  if (!value) return { valid: true, type: null };
  
  const digits = value.replace(/\D/g, '');
  
  if (digits.length === 11) {
    return { valid: validateCPF(digits), type: 'cpf' };
  } else if (digits.length === 14) {
    return { valid: validateCNPJ(digits), type: 'cnpj' };
  } else if (digits.length > 0 && digits.length < 11) {
    return { valid: false, type: 'incomplete', message: 'CPF deve ter 11 dígitos' };
  } else if (digits.length > 11 && digits.length < 14) {
    return { valid: false, type: 'incomplete', message: 'CNPJ deve ter 14 dígitos' };
  }
  
  return { valid: false, type: null };
};

// Format CPF: 000.000.000-00
export const formatCPF = (value) => {
  const digits = value.replace(/\D/g, '').substring(0, 11);
  return digits
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

// Format CNPJ: 00.000.000/0000-00
export const formatCNPJ = (value) => {
  const digits = value.replace(/\D/g, '').substring(0, 14);
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
};

// Format CPF or CNPJ based on length
export const formatCpfCnpj = (value) => {
  const digits = value.replace(/\D/g, '');
  if (digits.length <= 11) {
    return formatCPF(digits);
  } else {
    return formatCNPJ(digits);
  }
};

// Format CEP: 00000-000
export const formatCEP = (value) => {
  const digits = value.replace(/\D/g, '').substring(0, 8);
  return digits.replace(/(\d{5})(\d)/, '$1-$2');
};

// Format Phone: (00) 00000-0000
export const formatPhone = (value) => {
  if (!value) return '';
  const digits = value.replace(/\D/g, '');
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  } else if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return value;
};
